import basketball from './icons/basketball-ball';
import cup from './icons/cup';
import done from './icons/done';
import soccer from './icons/soccer-ball';
import voleyball from './icons/voleyball-ball';

export const iconsMap = {
  'down-indicator': require('./icons/down-indicator.svg').default,
};

export const pathsMap = {
  cup: cup,
  'baskeball-ball': basketball,
  'soccer-ball': soccer,
  'voleyball-ball': voleyball,
  done: done,
};
